import { Pipe, PipeTransform } from '@angular/core';
import { CommonBrickSettingsSelectors } from '../../store/dashboard/brick-wall/brick-settings/common-brick-settings/common-brick-settings.selectors';
import { filter, map, switchMap } from 'rxjs/operators';
import _ from 'lodash';
import { of } from 'rxjs';
import { Store } from '@ngxs/store';
import { BrickInstancesSelectors } from '../../store/dashboard/brick-wall/brick-instances/brick-instances.selectors';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
   name: 'instanceIdToBrickTitle$',
})
export class InstanceIdToBrickTitlePipe implements PipeTransform {
   constructor(private store: Store, private translationService: TranslateService) {}

   transform(brickInstanceId: string): any {
      const brickInstanceDescription$ = this.store.select(BrickInstancesSelectors.brickDescriptionFn).pipe(map((fn) => fn(brickInstanceId)));

      return this.store.select(CommonBrickSettingsSelectors.getOverwrittenBrickTitleFn).pipe(
         map((fn) => fn(brickInstanceId)),
         switchMap((overwrittenTitle) =>
            _.isEmpty(overwrittenTitle)
               ? brickInstanceDescription$.pipe(
                    filter((x) => !_.isNil(x)),
                    map((x) => x.definition.brickTitleTranslationKey),
                    switchMap((key) => this.translationService.stream(key))
                 )
               : of(overwrittenTitle)
         )
      );
   }
}
